import React from 'react';
import { Box } from '@mui/material';
import { Logo } from '../images';
import { useIntl } from 'react-intl';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1),
        marginBottom: 40,
        [theme.breakpoints.up('sm')]: {
            marginTop: 'auto'
        }
    },
    logo: {
        width: 108,
        '& path': {
            fill: '#CDD1D4'
        }
    }
}));

export const DashboardLogo = () => {
    const classes = useStyles();
    const { locale } = useIntl();

    return (
        <Box className={classes.logoContainer}>
            <Logo locale={locale} className={classes.logo} type="large" variant="no_text" />
        </Box>
    );
};
